import React, { Component } from 'react';
import { Create, SimpleForm, TextInput} from 'react-admin';


export default class SegmentationsOptionsCreate extends Component{
    render(){
        return(
            <Create {...this.props} title="Crear una nueva segmentación">
                <SimpleForm>
                    <TextInput source="name" label="Nombre"/>
                </SimpleForm>
            </Create>
        )
    }
}